export const PROFESSIONAL_MODE_STORAGE_KEY = 'profesionalMode';

export function isProfessionalModeEnabled(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return localStorage.getItem(PROFESSIONAL_MODE_STORAGE_KEY) === 'true';
}

export function setProfessionalMode(enabled: boolean): void {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.setItem(PROFESSIONAL_MODE_STORAGE_KEY, enabled ? 'true' : 'false');
}
